import type { IconGlyph } from '../icon';

/**
 * Tractie `settings-thick` glyph (medium, 24×24), shown on the current nav item.
 *
 * Source: `@tractie/icons` v1.5.0, `dist/jsx/m/settings-thick.jsx`.
 * Verbatim copy of the SVG `d` attributes, 2 paths in source order.
 */
export const iconSettingsThick: IconGlyph = {
  name: 'settings-thick',
  path: [
    'M12 9c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3m0 4c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1',
    'M22 13.84v-3.69l-2.86-.81-.21-.51 1.44-2.58-2.61-2.64-2.6 1.46-.5-.21-.82-2.87h-3.68l-.82 2.85-.47.19L6.25 3.6 3.61 6.24l1.43 2.62-.17.42-2.86.84v3.72l2.87.84.18.42-1.44 2.62 2.64 2.63 2.61-1.43.43.18.83 2.87h3.74l.83-2.87.47-.2 2.59 1.44 2.61-2.61-1.44-2.6.21-.5 2.86-.82Zm-4.11 3.58-.48.48-2.12-1.18-2.24.94-.68 2.34h-.73l-.68-2.34-2.2-.92-2.14 1.17-.52-.52 1.18-2.15-.92-2.19-2.34-.69v-.73l2.35-.69.91-2.19-1.17-2.14.52-.52 2.14 1.17 2.24-.91.67-2.34h.67l.67 2.34 2.29.95 2.12-1.19.48.49-1.18 2.12.95 2.3 2.34.66v.67l-2.34.67-.95 2.28 1.18 2.12Z',
  ],
};
